import { render, staticRenderFns } from "./DeanAdmissionsStudentWrapper.vue?vue&type=template&id=2860084c"
import script from "./DeanAdmissionsStudentWrapper.vue?vue&type=script&lang=js"
export * from "./DeanAdmissionsStudentWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports